<template>
  <div class="sf-container">
    <MathLevelYearTabs v-model="defaultYear" class="sf-year-tabs tw-mb-4" />
    <DbMathLevels :default-year="defaultYear" />
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import DbMathLevels from '@/components/dashboard/DbMathLevels.vue';
import MathLevelYearTabs from '@/components/dashboard/MathLevelYearTabs.vue';

export default defineComponent({
  components: { DbMathLevels, MathLevelYearTabs },
  data() {
    return {
      defaultYear: 1,
    };
  }
});
</script>